import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ApplicationStep3 } from "./../../models/classes/ApplicationStep3.class";


export interface ApplicationStep3States {
  isCompleted:boolean,
  formData:ApplicationStep3
}

const initialState: ApplicationStep3States = {
  isCompleted:false,
  formData: new ApplicationStep3()
};


const ApplicationStep3Slice = createSlice({
  name:"Application Step 3 Slice",
  initialState,
  reducers:{
    updateFormData: (state, action: PayloadAction<ApplicationStep3>) => {
      state.formData = action.payload;
    },
    setCompleted: (state, action: PayloadAction<boolean>) => {
      state.isCompleted = action.payload;
    },
    resetFormData: (state)=>{
      state.formData = new ApplicationStep3();
    }
  },
  extraReducers: {}
});


export const { updateFormData, setCompleted, resetFormData } = ApplicationStep3Slice.actions;

export default ApplicationStep3Slice.reducer;